import * as THREE from "three";

/**
 * Input tracks keyboard + mouse:
 *  - keys / pressed(): held state + one-shot key edges
 *  - mouseDown (LMB, attack), rightDown (RMB, block)
 *  - middleDown + consumeDragX(): middle-drag to spin the camera
 *  - groundPoint(camera): cursor position on the y=0 floor plane
 */
export class Input {
  constructor(canvas) {
    this.canvas = canvas;
    this.keys = {};
    this._edges = {};
    this.mouse = new THREE.Vector2(0, 0);
    this.mouseDown = false;
    this.rightDown = false;
    this.middleDown = false;
    this._dragX = 0;

    this._raycaster = new THREE.Raycaster();
    this._groundPlane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
    this._hit = new THREE.Vector3();

    window.addEventListener("keydown", (e) => {
      const k = e.key.toLowerCase();
      if (!this.keys[k]) this._edges[k] = true;
      this.keys[k] = true;
      if (k === " ") e.preventDefault();
    });
    window.addEventListener("keyup", (e) => { this.keys[e.key.toLowerCase()] = false; });

    // Clear ALL held input whenever the window loses focus or is hidden. Without
    // this, alt-tabbing (or clicking away) while holding a movement key means the
    // browser never delivers the keyup, so the key stays "held" and the player
    // runs in that direction forever until you tap it again. This is the fix.
    this._releaseAll = () => {
      this.keys = {}; this._edges = {};
      this.mouseDown = false; this.rightDown = false; this.middleDown = false; this._dragX = 0;
    };
    window.addEventListener("blur", this._releaseAll);
    document.addEventListener("visibilitychange", () => { if (document.hidden) this._releaseAll(); });

    window.addEventListener("mousemove", (e) => {
      this.mouse.x = (e.clientX / window.innerWidth) * 2 - 1;
      this.mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;
      if (this.middleDown) this._dragX += e.movementX || 0;
    });
    window.addEventListener("mousedown", (e) => {
      if (e.button === 0) { if (e.target === canvas) this.mouseDown = true; }        // attack only over the world
      else if (e.button === 2) { if (!(e.target && e.target.closest && e.target.closest(".inventory"))) this.rightDown = true; } // block (not in menus)
      else if (e.button === 1) { this.middleDown = true; e.preventDefault(); }        // camera drag
    });
    window.addEventListener("mouseup", (e) => {
      if (e.button === 0) this.mouseDown = false;
      else if (e.button === 2) this.rightDown = false;
      else if (e.button === 1) this.middleDown = false;
    });
    // block right-click menu over the game; the inventory panel handles its own
    canvas.addEventListener("contextmenu", (e) => e.preventDefault());
  }

  pressed(key) {
    if (this._edges[key]) { this._edges[key] = false; return true; }
    return false;
  }
  endFrame() { this._edges = {}; }

  /** Accumulated horizontal middle-drag since last read (pixels). */
  consumeDragX() { const d = this._dragX; this._dragX = 0; return d; }

  groundPoint(camera, out = new THREE.Vector3()) {
    this._raycaster.setFromCamera(this.mouse, camera);
    if (this._raycaster.ray.intersectPlane(this._groundPlane, this._hit)) out.copy(this._hit);
    return out;
  }
}
